/* ModalRemoveExportedVideo.js */
/* @author: anghello */

import React, { useCallback } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function ModalRemoveExportedVideo({open, setOpen, confirm}) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <Modal isOpen={open} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>
        {Strings('confirm_remove_exported_video')}
      </ModalHeader>
      <ModalBody>
        {Strings('confirm_remove_exported_video_message')}
      </ModalBody>
      <ModalFooter>
        <Button
          color='secondary'
          onClick={toggle}
        >
          {Strings('cancel')}
        </Button>
        <Button
          color='danger'
          onClick={() => {
            toggle();
            if (confirm) { confirm() ; }
          }}
        >
          {Strings('yes_remove')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
